import React from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import APIS from "../../constant/EndPoint";
import { useForm } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
const UpdateBranch = ({ profile, setOpenUpdatebranchPopup }: any) => {
  const { mutateAsync: branchUpdateAsync, isLoading: isPatchLoading } =
    usePatchHook({
      queryKey: ["Staff"],
      navigateURL: "",
    });
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.USER}${profile?.user?.id}/update-default-branch/`;
    let formData = {
      ...values,
    };
    try {
      const res = await branchUpdateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOpenUpdatebranchPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        branch: profile?.branch,
      };
    },
  });

  return (
    <div>
      <form onSubmit={handleSubmit((data: any) => handleEdit(data, setError))}>
        <div className={tw` w-full gap-x-2 flex flex-row  items-center`}>
          <div className={tw`w-3/4`}>
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"branch"}
            register={register("branch")}
            errors={errors?.branch}
            name={"branch"}
            label={"Branch"}
            props={{
              is_active:true,
            }}
            setValue={setValue}
            placeholder={"Select Branch"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          </div>
      
          <div className={tw`w-32 relative top-5`}>
            <Button label={"Update"} />
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdateBranch;
